<template>
  <div>
    <el-button @click="dialogVisible = true">设置分类</el-button>
    <el-dialog
      title="设置分类"
      :visible="dialogVisible"
      width="1000px"
      @close="closeDialog"
    >
      <el-table
        class="category-table"
        :data="announcementCategories"
        :row-key="() => Math.random()"
      >
        <el-table-column
          v-for="lang in languages"
          :key="lang.value"
          :label="`分类（${lang.label}）`"
        >
          <template slot-scope="scope">
            <el-input
              :value="scope.row.name[lang.value]"
              @input="update(scope.row, lang.value, $event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="是否首页展示">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.scroll"
              active-color="#13ce66"
              @input="update(scope.row, 'scroll', $event)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column width="60px">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="remove(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        class="create-button"
        type="success"
        icon="el-icon-plus"
        @click="create"
        >添加分类</el-button
      >
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LANGUAGES from 'common/languages';
import { mapState, mapActions, mapMutations } from 'vuex';
import SortableMixin from 'mixins/SortableMixin';

export default {
  name: 'AnnouncementCategories',
  mixins: [SortableMixin],
  data() {
    return {
      sortable: '.category-table',
      sortableSync: 'dialogVisible',
      dialogVisible: false,
      languages: Object.keys(LANGUAGES).map(lang => {
        return {
          label: LANGUAGES[lang],
          value: lang
        };
      })
    };
  },
  computed: {
    ...mapState('announcement', [
      'announcementCategories',
      'announcementCategoriesOrigin'
    ])
  },
  methods: {
    ...mapActions('announcement', ['listCategories', 'updateCategories']),
    ...mapMutations('announcement', ['setAnnouncementCategories']),
    closeDialog() {
      this.dialogVisible = false;
      this.setAnnouncementCategories(this.announcementCategoriesOrigin);
    },
    update(category, key, value) {
      const categories = JSON.parse(
        JSON.stringify(this.announcementCategories)
      ).map(item => {
        if (category.id === item.id) {
          if (key === 'scroll') {
            item[key] = value;
          } else {
            item.name[key] = value;
          }
        }

        return item;
      });

      this.setAnnouncementCategories(categories);
    },
    create() {
      let id = 0;
      this.announcementCategories.forEach(category => {
        id = Math.max(category.id, id);
      });

      this.setAnnouncementCategories([
        ...this.announcementCategories,
        {
          id: id + 1,
          name: {},
          scroll: false
        }
      ]);
    },
    remove(category) {
      const categories = this.announcementCategories.filter(
        item => item.id !== category.id
      );

      this.setAnnouncementCategories(categories);
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;

      if (oldIndex !== newIndex) {
        const categories = this.announcementCategories.slice();

        categories.splice(newIndex, 0, categories.splice(oldIndex, 1)[0]);
        this.setAnnouncementCategories(categories);
      }
    },
    save() {
      this.updateCategories(this.announcementCategories).then(() => {
        this.$message.success('更新成功！');
        this.listCategories();
        this.dialogVisible = false;
      });
    }
  },
  created() {
    this.listCategories();
  }
};
</script>

<style lang="less" scoped>
.create-button {
  margin-top: 10px;
}
</style>
